/**
 * /secretariat/planning
 * Réutilise le composant BoSecretariatPlanningPage existant (drag & drop, mobile liste).
 */
import React from 'react';
import BoSecretariatPlanningPage from '../bo/BoSecretariatPlanningPage';

export default function SecretariatPlanningPage() {
  return <BoSecretariatPlanningPage embedded />;
}
